/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React, { useEffect, useState } from "react";
import { DynamicObject, IQueryTableColumnDetails } from "../Interfaces";

export const ListRecords: React.FC<{ columnDetails: IQueryTableColumnDetails[], 
                                     dataRecords: DynamicObject[],
                                     errorCategoryName?: string,
                                     tableName?:string,
                                     renderRowData?: (row: DynamicObject) => React.ReactNode, 
                                     renderActions?: (row: DynamicObject) => React.ReactNode 
                                      }> = (props) => {

  
    let recordCount = 0;
    const recordElements: React.ReactElement[] = [];


    for(const recKey in props.dataRecords) {
        const record: DynamicObject = props.dataRecords[recKey];

        let primaryKey: any = null;
        let primaryKeyColumn: any = null;
            
        recordElements.push(
            <tr id={primaryKey} key={recordCount++}>
                {props.renderRowData ? props.renderRowData(record) : null}
                {props.renderActions ? props.renderActions(record) : null}
            </tr>
        );
    }



    return(
        <>
        <tbody className="table-group-divider">
            {recordElements}
        </tbody>
        </>
    );
}




